import type { FormBodyProps } from './form-body.interface';
import type { FC } from 'react';

import classNames from 'classnames';
import React from 'react';

export const FormBody: FC<FormBodyProps> = ({
  children,
  noMargin,
}: FormBodyProps) => (
  <div
    className={classNames('form-body', noMargin ? 'form-body_no-margin' : '')}
  >
    {children}
  </div>
);
